import { Box, Grid } from '@mui/material';
import styled from 'styled-components';
import { ReactComponent as Logo } from '../../logo.svg';

const RootContainer = styled(Box)`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #181e25;
  padding: 1rem;
  @media (min-width: 600px) {
    padding: 2rem;
  }
`;

const BrandingBox = styled(Box)`
  background: #377dff;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 24px 0 0 24px;
  @media (max-width: 900px) {
    border-radius: 24px 24px 0 0;
    min-height: 150px;
    padding: 24px 0;
  }
  @media (max-width: 600px) {
    min-height: 120px;
    padding: 16px 0;
  }
`;

const FormBox = styled(Box)`
  background: #232933;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 48px 32px;
  border-radius: 0 24px 24px 0;
  @media (max-width: 900px) {
    border-radius: 0 0 24px 24px;
    padding: 32px 16px;
  }
  @media (max-width: 600px) {
    padding: 24px 16px;
  }
`;

const Card = styled(Box)`
  width: 100%;
  max-width: 1100px;
  border-radius: 24px;
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
  overflow: hidden;
  background: transparent;
`;

interface AuthLayoutProps {
  children: React.ReactNode;
}

const AuthLayout = ({ children }: AuthLayoutProps) => {
  return (
    <RootContainer>
      <Card>
        <Grid container sx={{ minHeight: { xs: 'auto', md: 600 } }}>
          <Grid size={{xs:12, md:6}}>
            <BrandingBox>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Logo style={{ width: 'auto', height: 'auto', maxWidth: '200px', maxHeight: '60px' }} />
              </Box>
            </BrandingBox>
          </Grid>
          <Grid size={{xs:12, md:6}}>
            <FormBox>
              {children}
            </FormBox>
          </Grid>
        </Grid>
      </Card>
    </RootContainer>
  );
};

export default AuthLayout; 